(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header');
      if (!this.header) return;
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      const scrollTop = Math.max(0, window.scrollY);
      const headerTop = this.header.getBoundingClientRect().top + scrollTop;
      this.headerBounds = { top: Math.max(0, headerTop), bottom: 0 };
      this.isHomepage = this.dataset.homepage === 'true';
      this.bannerElements = this.isHomepage ? Array.from(document.querySelectorAll('.jv-banners')) : [];
      this.setHeaderHeight();

      this.onResizeHandler = this.setHeaderHeight.bind(this);
      window.addEventListener('resize', this.onResizeHandler);
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.onResizeHandler);
        this.resizeObserver.observe(this.header);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = Math.max(0, window.scrollY);
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.onFocusHandler = () => {
        if (window.scrollY > this.headerBounds.bottom) this.reveal();
      };
      this.addEventListener('focusin', this.onFocusHandler);

      // The Shopify editor can insert, remove or reorder the banner section.
      if (this.isHomepage) {
        this.onBannerLayoutHandler = () => {
          cancelAnimationFrame(this.bannerFrame);
          this.bannerFrame = requestAnimationFrame(() => {
            if (!this.isConnected) return;
            this.bannerElements = Array.from(document.querySelectorAll('.jv-banners'));
            this.updateHeaderSurface();
          });
        };
        this.bannerEditorEvents = ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'];
        this.bannerEditorEvents.forEach((event) => document.addEventListener(event, this.onBannerLayoutHandler));
        window.addEventListener('pageshow', this.onBannerLayoutHandler);
        window.addEventListener('load', this.onBannerLayoutHandler);
      }
    }

    setHeaderHeight() {
      const height = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      this.headerBounds.bottom = this.headerBounds.top + height;
      this.updateHeaderSurface();
    }

    updateHeaderSurface() {
      // Use the strip where the header will be revealed, even while it is hidden.
      // A banner lower in the viewport must not make a header over white content transparent.
      const top = this.header.classList.contains('shopify-section-header-sticky')
        ? 0
        : Math.max(0, this.header.getBoundingClientRect().top);
      const bottom = top + this.header.offsetHeight;
      const overBanner = this.isHomepage && this.bannerElements.some((banner) => {
        const rect = banner.getBoundingClientRect();
        return rect.height > 0 && rect.width > 0 && rect.top <= top + 1 && rect.bottom >= bottom - 1;
      });
      this.header.classList.toggle('jv-header-over-banners', overBanner);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      this.removeEventListener('focusin', this.onFocusHandler);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.clearTimeout(this.isScrolling);
      cancelAnimationFrame(this.bannerFrame);
      if (this.bannerEditorEvents) {
        this.bannerEditorEvents.forEach((event) => document.removeEventListener(event, this.onBannerLayoutHandler));
        window.removeEventListener('pageshow', this.onBannerLayoutHandler);
        window.removeEventListener('load', this.onBannerLayoutHandler);
      }
    }

    onScroll() {
      const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      const scrollTop = Math.min(maxScroll, Math.max(0, window.scrollY));
      this.updateHeaderSurface();

      // Don't hide a menu/search being used or a keyboard-focused control.
      if (
        (this.predictiveSearch && this.predictiveSearch.isOpen) ||
        this.querySelector('header-drawer details[open], details-modal details[open]') ||
        (this.contains(document.activeElement) && document.activeElement.matches(':focus-visible'))
      ) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
